import React from "react";
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  FormInput,
  FormSelect,
  FormTextarea,
  Button
} from "shards-react";
import { toast } from 'react-toastify';


import PageTitle from "../../../components/common/PageTitle";
import "./Inquiry.scss";

let submitDataInit = {
  boardName: "inquiry",
  status: "published",
  visibility: "private",
  isSecret: true,
  locked: false,
  contact: "",
  email: "",
  title: "",
  info_2: "",
  inquiryType: "general",
  content: "",
  attachments: [],
}

@inject(({ teamUser }) => ({isLogin: teamUser.isLogin, me: teamUser.me}))
@inject(({ board }) => ({updateBoard: board.updateBoard}))
@inject(({ common }) => ({uploadImages: common.uploadImages}))

@observer
class Inquiry extends React.Component {
  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {}
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  //page
  @observable submitData = submitDataInit;
  @observable isUploading = false;

  componentDidMount() {
    this.init();
  }

  @action
  init = async () => {
    if(this.props.isLogin) {
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.submitData.store_id = this.store._id;
      this.submitData.teamUser_id = this.teamUser._id;
      this.submitData.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo : 1;
      this.submitData.authorName = this.teamUser.name ? this.teamUser.name : "";
      this.submitData.email = this.teamUser.email ? this.teamUser.email : "";
    }
  };

  initNewInquiry = async () => {
    this.submitData = { ...submitDataInit, attachments: [] };
    this.submitData.store_id = this.store._id;
    this.submitData.teamUser_id = this.teamUser._id;
    this.submitData.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo : 1;
    this.submitData.authorName = this.teamUser.name ? this.teamUser.name : "";
    this.submitData.email = this.teamUser.email ? this.teamUser.email : "";
  };

  formatPhoneNumber = (value) => {
    // 숫자만 추출
    const numbers = value.replace(/[^\d]/g, '');

    // 길이에 따라 포맷팅
    if (numbers.length <= 3) {
      return numbers;
    } else if (numbers.length <= 7) {
      return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    } else if (numbers.length <= 11) {
      return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`;
    } else {
      return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}`;
    }
  };

  onChangeValue = async (event) => {
    const { name, value } = event.target;

    // 핸드폰 번호인 경우 자동 포맷팅
    if (name === 'contact') {
      this.submitData[name] = this.formatPhoneNumber(value);
    } else {
      this.submitData[name] = value;
    }
  };

  onFileChange = async (event) => {
    const inputEl = event.target;
    const files = inputEl.files;
    if (!files || files.length === 0) return;

    const maxFiles = 5;
    const currentCount = (this.submitData.attachments || []).length;
    if (currentCount + files.length > maxFiles) {
      toast(`이미지는 최대 ${maxFiles}개까지 첨부 가능합니다.`);
      if (inputEl) inputEl.value = "";
      return;
    }

    this.isUploading = true;
    try {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (!file.type.startsWith('image/')) {
          toast('이미지 파일만 첨부 가능합니다.');
          continue;
        }
        if (file.size / 1000000 > 10) {
          toast(`${file.name} 은(는) 10MB를 초과하여 첨부할 수 없습니다.`);
          continue;
        }

        const formData = new FormData();
        formData.append("file", file);

        const res = await this.props.uploadImages(formData);
        if (res && Array.isArray(res) && res[0] && res[0].fullPath) {
          if (!this.submitData.attachments) this.submitData.attachments = [];
          const isImage = file.type && file.type.startsWith('image/');
          this.submitData.attachments.push({
            type: isImage ? 'image' : 'file',
            url: res[0].fullPath,
            size: file.size,
            meta: { filename: file.name, mime: file.type }
          });
        } else {
          toast(`${file.name} 업로드에 실패했습니다.`);
        }
      }
      toast.success('이미지가 첨부되었습니다.');
    } catch (err) {
      console.error(err);
      toast('이미지 업로드 중 오류가 발생했습니다.');
    } finally {
      this.isUploading = false;
      if (inputEl) inputEl.value = "";
    }
  };

  removeAttachment = (index) => {
    if (!this.submitData.attachments) return;
    this.submitData.attachments.splice(index, 1);
  };

  onSubmit = async (data) => {
    let _this = this;
    let validFields = [
      {fildName: "authorName", alert: "담당자 이름을 입력해 주세요."},
      {fildName: "contact", alert: "핸드폰 번호를 입력해 주세요."},
      {fildName: "email", alert: "이메일 주소를 입력해 주세요."},
      {fildName: "title", alert: "문의 제목을 입력해 주세요."},
      {fildName: "content", alert: "문의 내용을 입력해 주세요."},
    ];
    let isValid = true;
    for(let i=0; i<validFields.length; i++) {
      if(!data[validFields[i].fildName] || data[validFields[i].fildName] === '') {
        toast(validFields[i].alert);
        isValid = false;
        break;
      }
    }

    data.notifyAuthor = true;
    if(isValid) {
      this.props.updateBoard(data, function(res) {
        if(res.errors && res.errors.length > 0) {
          toast(res.errors[0].message);
        }
        else {
          toast("문의가 접수되었습니다. 빠른 시일 내에 답변 드리겠습니다.");
          // 성공 시 내 문의 페이지로 이동
          window.location.href = "/myBoard";
        }
        _this.initNewInquiry();

      });
    }

  };

  render() {

    return (
      <Container fluid className="main-content-container px-4">
        <Row noGutters className="page-header py-4">
          <PageTitle
            title="문의하기"
            subtitle="궁금한 사항이나 문제가 있으시면 문의해주세요."
            className="text-sm-left mb-3"
          />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4">
              <CardHeader className="border-bottom">
                <h6 className="m-0">문의 정보 입력</h6>
              </CardHeader>
              <CardBody className="p-0 pb-3">
                <div className="p-4 mb-3 bg-info-light border-left-info" style={{backgroundColor: '#fff3cd', borderLeft: '4px solid #ffc107'}}>
                  <p className="mb-2" style={{fontSize: '1.1rem'}}>
                    <strong><span role="img" aria-label="말풍선">💬</span> 빠른 상담이 필요하신가요?</strong>
                  </p>
                  <p className="mb-2" style={{fontSize: '0.95rem'}}>
                    <a href={`https://onnomad.co.kr/embed/chat?service=온리플&id=${encodeURIComponent(this.store.platformId || '')}&shopName=${encodeURIComponent(this.store.name || '')}`} target="_blank" rel="noopener noreferrer" style={{textDecoration: 'underline', fontWeight: 'bold', color: '#ffc107'}}>상담쳇</a>을 통해
                    <strong> 실시간으로</strong> 문의하실 수 있습니다.
                  </p>
                  <p className="mb-0 text-muted" style={{fontSize: '0.9rem'}}>
                    ✓ 평일 오전 10시 ~ 오후 6시 실시간 상담 가능<br/>
                    ✓ 일반 문의는 아래 양식을 이용해주세요
                  </p>
                </div>
                <Form className="p-3" onSubmit={this.onSubmit}>
                  <Row form>
                    <Col md="6" className="form-group">
                      <label htmlFor="name">쇼핑몰</label>
                      <FormInput
                          id="name"
                          name="name"
                          type="text"
                          disabled={true}
                          placeholder="쇼핑몰명"
                          value={this.store && this.store.name ? this.store.name : ""}
                      />
                    </Col>
                    <Col md="6" className="form-group">
                      <label htmlFor="authorName">담당자</label>
                      <FormInput
                          id="authorName"
                          name="authorName"
                          type="text"
                          placeholder="담당자 이름을 입력해주세요."
                          value={this.submitData.authorName ? this.submitData.authorName : ""}
                          onChange={event => {
                            this.onChangeValue(event)
                          }}
                      />
                    </Col>
                  </Row>
                  <Row form>
                    <Col md="6" className="form-group">
                      <label htmlFor="contact">핸드폰</label>
                      <FormInput
                        id="contact"
                        name="contact"
                        type="text"
                        placeholder="010-0000-0000"
                        required={true}
                        value={this.submitData.contact}
                        onChange={event => {
                          this.onChangeValue(event)
                        }}
                      />
                    </Col>
                    <Col md="6" className="form-group">
                      <label htmlFor="email">이메일</label>
                      <FormInput
                          id="email"
                          name="email"
                          type="email"
                          required={true}
                          placeholder="이메일 주소를 입력해주세요."
                          value={this.submitData.email}
                          onChange={event => {
                            this.onChangeValue(event)
                          }}
                      />
                    </Col>
                  </Row>
                  <FormGroup>
                    <label htmlFor="inquiryType">문의 유형</label>
                    <FormSelect
                        id="inquiryType"
                        name="inquiryType"
                        value={this.submitData.inquiryType}
                        onChange={event => {
                          this.onChangeValue(event)
                        }}
                    >
                      <option value="general">일반 문의</option>
                      <option value="technical">기술 문의</option>
                      <option value="billing">결제 문의</option>
                      <option value="feature">기능 개선 제안</option>
                      <option value="bug">버그 신고</option>
                      <option value="other">기타</option>
                    </FormSelect>
                  </FormGroup>
                  <FormGroup>
                    <label htmlFor="title">문의 제목</label>
                    <FormInput
                      id="title"
                      name="title"
                      type="text"
                      placeholder="문의 제목을 입력해주세요."
                      value={this.submitData.title}
                      onChange={event => {
                        this.onChangeValue(event)
                      }}
                    />
                  </FormGroup>

                  <FormGroup>
                    <label htmlFor="content">문의 내용</label>
                    <FormTextarea
                      id="content"
                      name="content"
                      placeholder="문의 내용을 상세히 입력해주세요. 스크린샷이나 오류 메시지가 있다면 함께 기재해주시면 더 빠른 답변이 가능합니다."
                      rows="8"
                      value={this.submitData.content}
                      onChange={event => {
                        this.onChangeValue(event)
                      }}
                    />
                  </FormGroup>

                  <FormGroup>
                    <label htmlFor="attachments">이미지 첨부 <span className="text-muted" style={{fontSize: '0.85rem'}}>(선택, 최대 5개 · 파일당 10MB 이하)</span></label>
                    <div>
                      <input
                        id="attachments"
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={this.onFileChange}
                        disabled={this.isUploading}
                        style={{display: 'block', marginBottom: 8}}
                      />
                      {this.isUploading && <p className="text-muted mb-2" style={{fontSize: '0.9rem'}}>업로드 중...</p>}
                      {this.submitData.attachments && this.submitData.attachments.length > 0 && (
                        <div style={{display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8}}>
                          {this.submitData.attachments.map((file, idx) => (
                            <div key={idx} style={{position: 'relative', width: 100, height: 100, border: '1px solid #e1e5eb', borderRadius: 4, overflow: 'hidden'}}>
                              <img src={file.url} alt={(file.meta && file.meta.filename) || file.name || ''} style={{width: '100%', height: '100%', objectFit: 'cover'}}/>
                              <button
                                type="button"
                                onClick={() => this.removeAttachment(idx)}
                                style={{
                                  position: 'absolute', top: 2, right: 2,
                                  width: 22, height: 22, lineHeight: '20px',
                                  padding: 0, border: 'none', borderRadius: '50%',
                                  background: 'rgba(0,0,0,0.6)', color: '#fff',
                                  cursor: 'pointer', fontSize: 14
                                }}
                                aria-label="첨부 삭제"
                              >×</button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </FormGroup>

                  <Row>
                    <Col className="text-center" ><Button onClick={event => this.onSubmit(this.submitData)} disabled={this.isUploading}>문의하기</Button></Col>
                  </Row>

                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Inquiry;
